import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MenuService } from '@frontend/shared/services/menu.service';
import { PromanMenuItem } from '@proman/interfaces/object-interfaces';
import { FilterService } from '@proman/services/filter.service';
import { hasUtfSubstring } from '@proman/utils';

@Component({
    selector: 'pm-dashboard-quick-search-dialog',
    template: `
        <pro-dialog-title title="search"></pro-dialog-title>
        <div mat-dialog-content fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="center center">
                <pm-txt
                    [value]="query"
                    [config]="{ label: 'search', autofocus: true, debounce: 0 }"
                    (onChange)="setQuery($event)"></pm-txt>
            </div>

            @if (filteredMenu.length) {
            <pro-label>{{ 'menu' | translate }}</pro-label>
            }
            <div class="List">
                @for (item of filteredMenu; track item) { @if (item.type) {
                <div class="List-row FontBold">{{ item.name | translate }}</div>
                @for (tab of item.tabs; track tab) {
                <div class="List-row LeftMargin Clickable" [routerLink]="tab.state | pmSref">
                    {{ tab.name | translate }}
                </div>
                } } @if (item.state) {
                <div class="List-row  Clickable" [routerLink]="item.state | pmSref">{{ item.name | translate }}</div>
                } }
            </div>
        </div>
        <pro-dialog-actions></pro-dialog-actions>
    `,
    standalone: false,
})
export class DashboardQuickSearchDialogComponent {
    data = inject(MAT_DIALOG_DATA);
    private Menu = inject(MenuService);
    private Filter = inject(FilterService);
    private dialogRef = inject<MatDialogRef<DashboardQuickSearchDialogComponent>>(MatDialogRef);

    query: string = '';

    menu: any[];
    filteredMenu: any[];
    constructor() {
        this.menu = this.Menu.get();
        this.filteredMenu = this.menu;
    }

    setQuery(value: string) {
        this.query = value;

        this.filterItems();
    }

    filterItems() {
        this.filteredMenu = this.menu.filter((item) => {
            if (item?.tabs) {
                return item.tabs.some((tab: PromanMenuItem) =>
                    hasUtfSubstring(this.Filter.translate(tab.name), this.query)
                );
            } else hasUtfSubstring(this.Filter.translate(item.name), this.query);
        });

        this.filteredMenu.forEach((item) => {
            if (item?.tabs) {
                item.tabs = item.tabs.filter((tab: PromanMenuItem) =>
                    hasUtfSubstring(this.Filter.translate(tab.name), this.query)
                );
            }
        });
    }
}
